<template>
  <div class="layout layout-personalities-banner my-4 md:my-6">
    <PersonalitiesBanner />
  </div>
</template>
